// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HomeCard_wrapper__1-6KR","comingSoon":"HomeCard_comingSoon__2AG-U","card":"HomeCard_card__yhUxO","link":"HomeCard_link__3v1L8","cardTitle":"HomeCard_cardTitle__12Sdw"};